import classNames, { Argument } from 'classnames'

export type ClassNamesType = Argument
export { classNames }
